import {
  NETWORK_LOG_MESSAGE_PATTERN,
  THIRD_PARTY_TELEMETRY_DOMAINS,
} from "@/lib/errors/third-party-telemetry-fetch-noise/constants";

/**
 * True for a network-origin Datadog log whose request went to a known
 * third-party injected script's own telemetry endpoint (see
 * `THIRD_PARTY_TELEMETRY_DOMAINS`).
 *
 * Only network-origin logs match, and only for the listed domains, so failed
 * requests to any other third-party host (uploads, embeds) still report.
 */
export function isThirdPartyTelemetryFetchNoise({
  origin,
  url,
  message,
}: {
  origin: string | undefined;
  url: string | undefined;
  message: string | undefined;
}): boolean {
  if (origin !== "network") {
    return false;
  }

  const host = _getHost(
    url ?? message?.match(NETWORK_LOG_MESSAGE_PATTERN)?.[1],
  );
  if (!host) {
    return false;
  }

  return THIRD_PARTY_TELEMETRY_DOMAINS.some(
    (domain) => host === domain || host.endsWith(`.${domain}`),
  );
}

function _getHost(url: string | undefined): string | undefined {
  if (!url) {
    return undefined;
  }

  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return undefined;
  }
}
